import { DailyRateService } from '../../service/daily-rate.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, OnInit } from '@angular/core';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { DatePipe } from '@angular/common';
import { CommonDataService } from 'src/app/core/services/common-data.service';

@Component({
  selector: 'laas-daily-rate-setting-edit',
  templateUrl: './daily-rate-setting-edit.component.html',
  styleUrls: ['./daily-rate-setting-edit.component.scss']
})
export class DailyRateSettingEditComponent extends SessionBaseComponent implements OnInit {

  dailyRate: any;
  editForm: FormGroup;
  rateTypeOptions: any[];
  currencyOptions: any[];

  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private dailyRateService: DailyRateService,
    private commonDataService: CommonDataService
  ) {
    super(injector);
    this.rateTypeOptions = [];
    this.currencyOptions = [];
    this.dailyRate = {
      seqNo: this.routeStateService.getCurrent().data.seqNo,
      rateType: '',
      dateTimeZone: '',
      fromCurrency: '',
      toCurrency: '',
      rate: '',
      rateYM: '',
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: '',
      isActivated: ''
    };

    this.editForm = this.formBuilder.group({
      seqNo: this.routeStateService.getCurrent().data.seqNo,
      rateType: '',
      dateTimeZone: '',
      fromCurrency: '',
      toCurrency: '',
      rate: '',
      rateYM: '',
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: '',
      isActivated: ''
    });
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    const seqNo = this.routeStateService.getCurrent().data.seqNo;

    try {
      this.dailyRate = await this.dailyRateService.getDailyRateDetail(seqNo);
      this.dailyRate.dateTimeZone = this.datePipe.transform(this.dailyRate.date, "yyyy/MM/dd", this.laasSetting.facilityTimeZone);
    } catch (err: any) {
      console.log('get daily rate occur error: ' + JSON.stringify(err));
    }

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'RateType').subscribe({
      next: result => {
        this.rateTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.currencyOptions.unshift({
          label: "請選擇",
          value: ""
        });
      }
    });

  }

  saveBtnClick(event: any): void {
    if (this.editForm.invalid) {
      this.toastService.warn(this.translateService.instant('ExchangeRate.Alert.CheckRequiredFields'));
      return;
    }

    //DateTime convert
    this.dailyRate.dateDt = isNullOrEmpty(this.dailyRate.dateDtTimeZone) ? null : new Date(this.dailyRate.dateDtTimeZone).toISOString();
    this.dailyRate.updateUser = this.userProfile.userName;

    this.dailyRateService.updateDailyRate(this.dailyRate).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave')
          .subscribe({
            next: msg => {
              this.toastService.success(msg);
              this.routeStateService.navigateTo('/Setting/DailyRateSetting', this.dailyRate);
            }
          });
      }
    });
  }

  goToLastPage(): void {
    this.routeStateService.loadPrevious();
  }

}
